import { useTranslation } from "react-i18next";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackSchnellCheckClick, trackWaldrechnerCtaClick } from "@/utils/tracking";

const APP_URL = "https://app.foresthub.app";
const WALDRECHNER_URL = "https://waldrechner.eu";

export const FinalCTA = () => {
  const { t } = useTranslation();

  return (
    <section 
      id="final-cta" 
      className="py-16 bg-[#1B4D3E]"
      data-testid="final-cta-section"
    >
      <div className="max-w-2xl mx-auto px-6 text-center">
        <h2 
          className="text-2xl sm:text-3xl font-semibold text-white mb-4"
          style={{ fontFamily: 'Outfit, sans-serif' }}
          data-testid="final-cta-headline"
        >
          {t('finalCta.headline')}
        </h2>

        <p className="text-base text-white/80 mb-8 max-w-lg mx-auto">
          {t('finalCta.description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href={APP_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={trackSchnellCheckClick}
          >
            <Button 
              className="bg-white text-[#1B4D3E] hover:bg-stone-100 h-12 px-8 rounded-lg text-base font-medium"
              data-testid="final-cta-primary"
            >
              {t('finalCta.primaryCta')}
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </a>
          
          <a 
            href={WALDRECHNER_URL} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={trackWaldrechnerCtaClick}
          >
            <Button 
              variant="outline" 
              className="border-2 border-white/30 text-white hover:bg-white/10 h-12 px-8 rounded-lg text-base font-medium w-full sm:w-auto"
              data-testid="final-cta-secondary"
            >
              <ArrowLeft className="mr-2 w-4 h-4" />
              {t('finalCta.secondaryCta')}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
